import React, { useState } from 'react';
import { apiFetch } from '../../../apiClient';
import { useAuth } from '../../../AuthContext';
import { avisar, mensagemDeErro } from '../../shared/Notificacao';
import { Botao, Campo, Etapas } from '../../egora';
import EntradaMoldura, { EntradaCabeca, EntradaErro } from './EntradaMoldura';
import CampoSenha from './CampoSenha';
import CodigosReserva from './CodigosReserva';

/**
 * Acesso restrito (item 4B-2): o 2º fator foi zerado e a conta só faz isto —
 * configurar o novo fator. Três passos, tudo em memória:
 *   1. senha atual            → segredo PENDENTE e QR;
 *   2. código do aplicativo   → o 2º fator fica ligado;
 *   3. códigos reserva        → mostrados UMA vez, depois a sessão termina.
 * Ligar o fator derruba as sessões no servidor, então ao fim o usuário entra de novo.
 */
const PASSOS = ['Sua senha', 'Aplicativo', 'Códigos reserva'];
const INDICE = { senha: 0, codigo: 1, codigos: 2 };

export default function ConfigurarSegundoFator() {
  const { logout } = useAuth();
  const [etapa, setEtapa] = useState('senha');
  const [senha, setSenha] = useState('');
  const [pendente, setPendente] = useState(null);
  const [codigo, setCodigo] = useState('');
  const [codigos, setCodigos] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');

  const configurar = async (e) => {
    e.preventDefault();
    setErro('');
    setCarregando(true);
    try {
      const res = await apiFetch('/api/auth/mfa/configurar', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ senha }),
      });
      const dados = await res.json().catch(() => ({}));
      if (res.ok) {
        setPendente(dados.data);
        setSenha('');
        setEtapa('codigo');
      } else {
        setErro(mensagemDeErro(dados));
      }
    } catch (err) {
      setErro('Servidor indisponível. Tente de novo.');
    } finally {
      setCarregando(false);
    }
  };

  const confirmar = async (e) => {
    e.preventDefault();
    setErro('');
    setCarregando(true);
    try {
      const res = await apiFetch('/api/auth/mfa/confirmar', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ senha, pendente_id: pendente.pendente_id, codigo }),
      });
      const dados = await res.json().catch(() => ({}));
      if (res.ok) {
        setCodigos(dados.data.codigos);
        setPendente(null);
        setSenha('');
        setCodigo('');
        setEtapa('codigos');
        avisar('Segundo fator ligado. Guarde os códigos reserva.', 'info');
      } else {
        setErro(mensagemDeErro(dados));
      }
    } catch (err) {
      setErro('Servidor indisponível. Tente de novo.');
    } finally {
      setCarregando(false);
    }
  };

  const terminar = () => {
    setCodigos([]);
    logout();
  };

  return (
    <EntradaMoldura>
      <Etapas etapas={PASSOS} atual={INDICE[etapa]} rotulo="Passos" />

      {etapa === 'senha' && (
        <form onSubmit={configurar} noValidate>
          <EntradaCabeca
            icone="phonelink_lock"
            tom="atencao"
            titulo="Configure o segundo fator"
            texto="A sua verificação em duas etapas foi zerada. Para usar o sistema, configure um novo aplicativo autenticador."
          />
          <EntradaErro>{erro}</EntradaErro>
          <CampoSenha rotulo="Sua senha atual" valor={senha} aoMudar={setSenha} placeholder="Confirme com a sua senha" autoFocus />
          <Botao type="submit" carregando={carregando} className="entrada__entrar">
            {carregando ? 'Gerando' : 'Continuar'}
          </Botao>
        </form>
      )}

      {etapa === 'codigo' && pendente && (
        <form onSubmit={confirmar} noValidate>
          <EntradaCabeca titulo="Escaneie o QR Code" texto="Use o aplicativo autenticador e digite o código de 6 dígitos." />
          <img src={pendente.qr_code} alt="QR Code para o aplicativo autenticador" className="entrada__qr" />
          <p className="entrada__chave">Ou digite a chave: <strong className="sj-num">{pendente.segredo}</strong></p>
          <EntradaErro>{erro}</EntradaErro>
          <CampoSenha rotulo="Sua senha atual" valor={senha} aoMudar={setSenha} placeholder="Confirme com a sua senha" />
          <Campo rotulo="Código de 6 dígitos">
            {(p) => (
              <input
                {...p}
                className="sj-campo__entrada sj-num entrada__codigo"
                inputMode="numeric"
                maxLength={6}
                required
                autoComplete="one-time-code"
                value={codigo}
                onChange={(e) => setCodigo(e.target.value.replace(/\D/g, ''))}
              />
            )}
          </Campo>
          <Botao type="submit" carregando={carregando} className="entrada__entrar">
            {carregando ? 'Confirmando' : 'Ligar o segundo fator'}
          </Botao>
        </form>
      )}

      {etapa === 'codigos' && (
        <CodigosReserva codigos={codigos} rotuloContinuar="Já guardei, entrar de novo" aoContinuar={terminar} />
      )}
    </EntradaMoldura>
  );
}
